var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("about")]),_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('input',{attrs:{"type":"text"},on:{"focus":_vm.tttt}}),_c('p',[_vm._v("about about about about")])])
}
var staticRenderFns = []

export { render, staticRenderFns }